import React from 'react'

import { Button } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { SearchPage_result_location } from '../../gql'
import { i18nKeyPrefix } from '../../i18n'
import { ButtonContainer, StyledLink, StyledText, TextContainer } from './SaveSearchForm.styles'

const PRE = `${i18nKeyPrefix}-SAVE-CONFIRMATION`

interface IProps {
  location: SearchPage_result_location | null
  setDisplayForm: React.Dispatch<React.SetStateAction<boolean>>
}

export default function ConfirmationForm(props: IProps) {
  const { location, setDisplayForm } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const city = location?.city
  const state = location?.state

  return (
    <React.Fragment>
      <TextContainer>
        <StyledText>
          {location && city && state ? t(`${PRE}-ADDED-CITY`, { city, state }) : t(`${PRE}-ADDED`)}
        </StyledText>
        <StyledLink to="/me/saved-searches">{t(`${PRE}-LINK`)}</StyledLink>
      </TextContainer>
      <ButtonContainer>
        <Button full onClick={() => setDisplayForm(false)}>
          {t(`${PRE}-BUTTON`)}
        </Button>
      </ButtonContainer>
    </React.Fragment>
  )
}
